const createEvent = (apiPost) => (body) => apiPost(`/me/calendar/events`, body);

export default createEvent;
